import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import ReportsHistoryPage from '@/ui/pages/Reports/history/ReportsHistoryPage';
import { reportsSearchSchema } from '@/ui/pages/Reports/history/reportsListModel';

/**
 * HS-961 / HS-1602: the report history, a `@smartsash/data-screen` definition. Data comes from the
 * mock transport until HS-1594 lands (`src/tmp/`).
 *
 * Unlike the entity lists, the route names only the search schema and loads the definition inside
 * its loader: `validateSearch`/`loaderDeps`/`loader` are not code-split, and binding the two list
 * routes to their definitions put both screens — and the mock transport — in the entry chunk
 * (9_800 B gz, measured in `size-limit.config.mjs`). The schema is the definition's own, and the
 * list searches and sorts on the server, so the deps are the search itself, exactly what the
 * definition's `loaderDeps` returns.
 */
export const Route = createFileRoute('/_dashboard/reports/')({
  validateSearch: (input: Record<string, unknown>) => reportsSearchSchema.parse(input),
  loaderDeps: ({ search }) => search,
  beforeLoad: requireRoute('/reports'),
  loader: async ({ context, deps }) => {
    const { reportsScreen } = await import('@/ui/pages/Reports/history/reportsScreen');
    return reportsScreen.loaderFor()({ context, deps });
  },
  component: ReportsHistoryPage,
});
